import type { IdvDocumentDisplay } from '@Types/MatchIdv.interface';

export const IdvDocuments: { [key: string]: IdvDocumentDisplay } = Object.freeze({
    NorthAmericanDriversLicense: {
        value: 'NaDriverLicense',
        display: "Driver's License or ID Card",
    },
    Passport: {
        value: 'Passport',
        display: 'Passport',
    },
    UsPassportCard: {
        value: 'UsPassportCard',
        display: 'US Passport Card',
    },
    Other: {
        value: 'Other',
        display: 'Other',
    },
});

